import { createSlice } from "@reduxjs/toolkit"
import { api } from './apiSlice'

export const catalogApiSlice = api.injectEndpoints({
    endpoints: build => ({
        getManufacturer: build.query({
            query: (manufacturerId) => ({
                url: `/catalog/manufacturer/${manufacturerId}`,
                method: 'GET'
            })
        }),
        searchManufacturers: build.query({
            query: ({ manufacturerId, manufacturerName }) => ({
                url: `/catalog/manufacturers/search`,
                method: 'GET',
                params: {
                    ...(manufacturerId ? { manufacturerId } : {}),
                    ...(manufacturerName ? { manufacturerName } : {}),
                },
            })
        }),
        getStoreById: build.query({
            query: (id) => ({
                url: `/catalog/store/${id}`,
                method: 'GET',
            })
        }),
    })
})

const initialState = []
const catalogSlice = createSlice({
    name: 'catalog',
    initialState,
    reducers: {},
})

export const {
    useLazyGetManufacturerQuery,
    useLazySearchManufacturersQuery,
    useLazyGetStoreByIdQuery,
} = catalogApiSlice

export default catalogSlice.reducer